module.exports = __webpack_public_path__ + "static/media/DSC04255.9604128d.jpg";